import { getRouteManifestEntry } from './routeManifest';

// Public presentation is independent of a visitor's OS or account preference.
export const getForcedRouteTheme = (pathname: string): 'light' | undefined => (
  getRouteManifestEntry(pathname)?.access === 'public' ? 'light' : undefined
);